import TabCoaches from "@/views/App/Dashboard/SiteManager/TabCoaches.vue";
import TabUnitsDoneByLocation from "@/views/App/Dashboard/SiteManager/TabUnitsDoneByLocation.vue";
import TabInfo from "@/views/App/Dashboard/SiteManager/TabInfo.vue";
import TabPotentialUnits from "@/views/App/Dashboard/SiteManager/TabPotentialUnits.vue";
import UnsignedUnitsLocation from "@/views/App/Dashboard/SiteManager/UnsignedUnitsLocation.vue";

const routesDashboardSiteManager= [
    {
        path: 'info',
        name: 'dashboardSiteManagerInfo',
        component: TabInfo
    },
    {
        path: 'coaches',
        name: 'dashboardSiteManagerCoaches',
        component: TabCoaches
    },
    {
        path: 'potential-units',
        name: 'dashboardSiteManagerPotentialUnits',
        component: TabPotentialUnits
    },
    {
        path: 'units_done_by_location',
        name: 'dashboardSiteManagerUnitsDoneByLocation',
        component: TabUnitsDoneByLocation
    },
    {
        path: 'unsigned-units-location/:locationId',
        name: 'dashboardSiteManagerUnsignedUnitsLocation',
        component: UnsignedUnitsLocation
    }
  ];

export default routesDashboardSiteManager;